import React, { createContext, useContext, useState } from 'react';
import Toast from '../Components/Toast';

const ToastContext = createContext();

export const useToast = () => useContext(ToastContext);

export const ToastProvider = ({ children }) => {
  const [toast, setToast] = useState(null);

  const showToast = (message, type = 'info', position = 'top-right', autoHide = true) => {
    setToast({
      message,
      type,
      position,
      autoHide,
      isOpen: true
    });
  };

  const hideToast = () => {
    setToast(null);
  };

  return (
    <ToastContext.Provider value={{ showToast, hideToast }}>
      {children}
      {toast && (
        <Toast
          toast={toast}
          resetToast={hideToast}
        />
      )}
    </ToastContext.Provider>
  );
};
